import React from "react";
import {
  Card,
  CardHeader,
  Col,
  CardBody,
} from "reactstrap";

import ReactApexChart from "react-apexcharts";

const ChannelDistribution = ({
  channels = [],
}) => {

  const categories =
    channels.map(
      (item) => item.channel
    );

  const seriesData =
    channels.map(
      (item) =>
        item.enabled
          ? 1
          : 0
    );

  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        distributed: true,
        columnWidth: "50%",
      },
    },

    colors: [
      "#0d6efd",
      "#198754",
      "#ffc107",
      "#dc3545",
      "#6610f2",
      "#20c997",
      "#fd7e14",
    ],

    xaxis: {
      categories,
    },

    yaxis: {
      max: 1,
      min: 0,
      tickAmount: 1,
      title: {
        text:
          "Connection Status",
      },
    },

    dataLabels: {
      enabled: true,
      formatter: function (
        val
      ) {
        return val === 1
          ? "Connected"
          : "Disabled";
      },
    },

    tooltip: {
      y: {
        formatter:
          function (val) {
            return val === 1
              ? "Connected"
              : "Disabled";
          },
      },
    },

    noData: {
      text:
        "No Channels Found",
    },
  };

  const series = [
    {
      name:
        "Connection",
      data: seriesData,
    },
  ];

  return (
    <Col xl={8}>
      <Card
        style={{
          height: "100%",
        }}
      >
        <CardHeader>
          <h4 className="card-title mb-0">
            Channel Connection
            Distribution
          </h4>
        </CardHeader>

        <CardBody>
          <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={350}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default ChannelDistribution;